import {HttpClient} from "../../service/httpClient/HttpClient";

export class MagazineWriterService {
    constructor() {
        this.httpClient = new HttpClient()
    }

    getWriters(page, size, fullName, nationalCode, phoneNumber) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `/post-writers`,
                {
                    page, size,
                    "phone-number": phoneNumber,
                    "national-code": nationalCode,
                    "full-name": fullName
                }
            ).then(resolve).catch(reject)
        })
    }

    createNewWriter(firstName, lastName, nationalCode, phoneNumber) {
        return new Promise((resolve, reject) => {
            this.httpClient.post(
                `/post-writers`,
                {
                    firstName,
                    lastName,
                    "notionalCode": nationalCode,
                    phoneNumber
                }
            ).then(resolve).catch(reject)
        })
    }

    getWriterInformation(writerId) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `/post-writers/${writerId}/information`
            ).then(resolve).catch(reject)
        })
    }

    updateWriterInformation(writerId, firstName, lastName, nationalCode, phoneNumber) {
        return new Promise((resolve, reject) => {
            this.httpClient.put(
                `/post-writers/${writerId}/information`,
                {
                    "firstName": firstName,
                    "lastName": lastName,
                    "phoneNumber": phoneNumber,
                    "nationalCode": nationalCode
                }
            ).then(resolve).catch(reject)
        })
    }

    getWriterAccess(writerId) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `/post-writers/${writerId}/enabled`
            ).then(resolve).catch(reject)
        })
    }

    updateWriterAccess(writerId, enabled) {
        return new Promise((resolve, reject) => {
            this.httpClient.put(
                `/post-writers/${writerId}/enabled`,
                {
                    enabled
                }
            ).then(resolve).catch(reject)
        })
    }


}